export default "__VITE_ASSET__QD_lwAcs__"